module.exports = __webpack_public_path__ + "static/media/hubspot-white-color.06eafc2a.svg";